import AnnualPassOption from './portal/annual-pass-option';
import { canPurchaseTicket } from 'app/utilities/buy-memberships';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import {
    DAY_PASS_OPTIONS,
    MEMBERSHIP_OPTIONS,
    MEMBERSHIP_TABS,
    TICKET_IMAGES
} from 'config/tickets-products';

const TicketCategory = ({ image, children }) => (
    <div className="flexi-item ticket annual-pass">
        <div className="media" style={{ backgroundImage: `url(${image})` }}>
            <div className="preserve-image-ratio">
                <img className="fixed-image" src={image} alt="" />
            </div>
        </div>
        {children}
    </div>
);

TicketCategory.propTypes = {
    image: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

const TicketsSection = () => {
    const user = useSelector((state) => state.auth.user);
    const userCanBuyTicket = canPurchaseTicket(user);

    const renderDayPassCategory = () => (
        <TicketCategory image={TICKET_IMAGES.DAY_PASS}>
            <div className="title-group annual-pass-wrapper light">
                <div className="annual-pass-description">
                    <h2 className="title-group-heading">Day Pass</h2>
                    <div className="title-group-content">
                        <p className="ticket-category-description">
                            There&apos;s lots to see and do at Auckland Zoo, all year round! Thanks to the generous support from Auckland Council, we can offer a subsidised ticket price to visitors who live in Auckland and book a minimum of one day in advance. For all visitors, visiting us during off-peak times (<i>during NZ school terms</i>) means you pay less than peak time (<i>weekends, public and school holidays</i>).
                        </p>
                    </div>
                </div>
                <div className="annual-pass-options-wrapper">
                    {DAY_PASS_OPTIONS.map((option, index) => (
                        <div key={index} className={option.title.includes('Gift') ? 'day-pass-gift' : ''}>
                            <AnnualPassOption from="tickets-section" {...option} />
                        </div>
                    ))}
                </div>
            </div>
        </TicketCategory>
    );

    const renderAnnualPassCategory = () => (
        <TicketCategory image={TICKET_IMAGES.MEMBERSHIP}>
            <div className="title-group annual-pass-wrapper light">
                <div className="annual-pass-description">
                    <h2 className="title-group-heading">Membership</h2>
                    <div className="title-group-content">
                        <p className="ticket-category-description">
                            Auckland Zoo&apos;s Annual Pass Membership gives you and your whānau unlimited entry to the Zoo 364 days a year and other great benefits. Plus, you&apos;ll be contributing to Auckland Zoo&apos;s conservation work at the Zoo and in the wild. <Link to="/visit/membership">More info</Link>
                        </p>
                    </div>
                </div>
                <div className="annual-pass-options-wrapper">
                    {MEMBERSHIP_OPTIONS[MEMBERSHIP_TABS.ANNUAL].map((option, index) => (
                        <AnnualPassOption
                            key={index}
                            from="tickets-section"
                            {...option}
                            isVisible={option.title.includes('Become') ? userCanBuyTicket : true}
                        />
                    ))}
                </div>
            </div>
        </TicketCategory>
    );

    return (
        <section className="tickets-section || flexi-block">
            <div className="constrain-width large">
                <div className="inner">
                    {renderDayPassCategory()}
                    {renderAnnualPassCategory()}
                </div>
            </div>
        </section>
    );
};

export default TicketsSection;
